import React from 'react';
import { styled } from "./../stitches.config"
import { h1 } from "./commonStyles/Fonts";

import image1 from '../assets/img/natemat/tip/tiphero1.webp';
import image2 from '../assets/img/natemat/tip/tiphero2.webp';
import image3 from '../assets/img/natemat/tip/tiphero3.webp';

interface JobOfferTitleProps {
    title: string,
    tags: Array<string>;
}

const JobOfferTitle: React.FC<JobOfferTitleProps> = ({
    title,
    tags,
    ...props
}) => {
    return (
        <OfferPageHero>
            <OrangeCircle />
            <OfferPageHeroContent>
                <h1 className={h1()}>{title}</h1>
                {tags.length > 0 &&
                    <Tags>
                        {tags.map((tag) =>
                            <Tag> {tag} </Tag>
                        )}
                    </Tags>
                }
                <StyledButton href="#job-offer-article__apply">Aplikuj teraz</StyledButton>
            </OfferPageHeroContent>
            <ImageNet>
                <div><img src={image1} alt="" style={{ width: '80%' }} /></div>
                <div>
                    <img src={image2} alt="" style={{ width: '45%' }} />
                    <img src={image3} alt="" style={{ width: '45%' }} />
                </div>
            </ImageNet>
        </OfferPageHero>
    );
};


const OrangeCircle = styled('div', {
    position: 'absolute',
    backgroundColor: '$natematPrimary',
    borderRadius: '50%',
    width: '150px',
    height: '150px',
    top: '50%',
    left: '50%',
    translate: '-50% -50%',
    filter: 'blur(200px)',
    '@bp4': {
        width: '200px',
        height: '200px',
        filter: 'blur(250px)',
    }
})

const StyledButton = styled('a', {
    backgroundColor: '$primary',
    color: '$grayscale0Fixed',
    border: 'none',
    height: 'auto',
    width: '100%',
    maxWidth: "328px",
    textAlign: 'center',
    fontFamily: '$bodyLarge',
    fontSize: '16px',
    lineHeight: '24px',
    padding: '13px 20px 13px 20px',
    display: "block",
    margin: "24px auto 0 auto",
    '@bp4': {
        margin: "40px 0 0 0",
        maxWidth: "131px",
        width: 'auto',
        height: 'auto',
        padding: '13px 20px 13px 20px',
    },
    "&:hover": {
        textDecoration: "none",
        color: "$grayscale0Fixed",
    }
})

const Tag = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '7px 15px 7px 15px',
    color: '$grayscale0Fixed',
    background: 'rgba(255, 255, 255, 0.2)',
})

const Tags = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    fontFamily: '$bodyLarge',
    width: "100%",
    flexWrap: "wrap",
    "@bp4": {
        justifyContent: "flex-start",
    }
})

const OfferPageHero = styled('div', {
    position: 'relative',
    background: '$grayscale100Fixed',
    display: 'flex',
    flexDirection: "column",
    paddingBottom: "400px",
    "@bp4": {
        paddingBottom: "0px",
        flexDirection: "row",
        height: '556px',
    }
})

const OfferPageHeroContent = styled('div', {
    color: '$grayscale0Fixed',
    maxWidth: "375px",
    padding: "0 12px",
    margin: "0 auto",
    "@bp4": {
        maxWidth: "100%",
        padding: 0,
        margin: '0 0 0 5%',
        alignSelf: 'center',
    },
    h1: {
        textAlign: "center",
        "@bp4": {
            textAlign: "left",
            marginTop: '0px',
            width: '50%',
        },
    },
    button: {
        marginTop: '24px',
        "@bp4": {
            marginTop: '40px',
        }
    },
})

const ImageNet = styled('div', {
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'absolute',
    zIndex: 10,
    bottom: -50,
    right: '50%',
    transform: 'translateX(50%)',
    div: {
        textAlign: 'center',
        img: {
            margin: '4px',
            verticalAlign: 'top',
        }
    },
    '@bp4': {
        width: '50%',
        transform: 'translateX(0%)',
        maxWidth: 'fit-content',
        top: 50,
        right: 0,
        div: {
            textAlign: 'center',
            img: {
                margin: '12px',
                verticalAlign: 'top',
            }
        },
    }
})

export default JobOfferTitle